// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.maintenance.RentalManagerMaintenanceConfigWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerMaintenanceConfigWebApiHandler_config,
  RentalManagerMaintenanceConfigWebApiHandler_config_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { RentalManagerMaintenanceConfigsDto } from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerMaintenanceConfigWebApiHandler_config_Options = UseQueryOptions<
  RentalManagerMaintenanceConfigsDto,
  unknown,
  RentalManagerMaintenanceConfigsDto,
  Array<string>
>;

const RentalManagerMaintenanceConfigWebApiHandler_config_GetKey = () => [
  RentalManagerMaintenanceConfigWebApiHandler_config_Path,
];

/**
 * Get maintenance configs
 */
export const useRentalManagerMaintenanceConfigWebApiHandler_config = (
  options: Omit<RentalManagerMaintenanceConfigWebApiHandler_config_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerMaintenanceConfigWebApiHandler_config_GetKey(),
    queryFn: () => RentalManagerMaintenanceConfigWebApiHandler_config(),
  });
};
useRentalManagerMaintenanceConfigWebApiHandler_config.getKey =
  RentalManagerMaintenanceConfigWebApiHandler_config_GetKey;
